<template>
  <div
    class="min-h-screen pb-4 grid grid-rows-[auto_1fr] bg-pitch-black text-total-white"
  >
    <!-- Top Header with Mason Logo -->
    <div
      class="flex w-full justify-between items-center px-4 p-3 border border-x-0 border-t-0 border-b-1 border-prime-golden bg-pitch-black-900"
    >
      <a href="/" class="text-prime-golden font-avenir-medium"
        ><img
          class="w-24 h-24 -my-8 -ml-[10px]"
          src="@/assets/images/mason-logo.svg"
          alt="Mason Logo"
      /></a>
      <p class="text-red-500 font-medium cursor-pointer" @click="logout">Logout</p>
    </div>

    <!-- Main Content Section -->
    <div
      class="w-full pt-6 flex flex-col justify-start lg:justify-center items-start mx-auto max-w-md px-4"
    >
      <!-- Header Section -->
      <div class="mb-6 text-left">
        <h1 class="text-3xl font-bold mb-4">Link Email Account</h1>
        <p class="text-sm text-total-white-500">
          To use all the features within the app, you must integrate your preferred email
          account. Please select one of the options below:
        </p>
      </div>

      <!-- Email Provider Buttons -->
      <div class="space-y-4 w-full">
        <button
          @click="linkGmail"
          class="w-full grid grid-cols-[1.05fr_1fr_1fr] px-6 items-center bg-dark-grey p-4 rounded-lg font-semibold hover:bg-pitch-black-500 transition ease-in-out duration-300 h-24"
        >
          <img src="../../assets/images/add.svg" class="justify-self-start" />
          <img
            src="../../assets/images/gmail-icon.svg"
            alt="Gmail"
            class="w-10 h-10 mx-auto"
          />
          <span class="flex items-center mx-auto"> Gmail </span>
        </button>

        <button
          @click="linkOutlook"
          class="w-full grid grid-cols-[1.2fr_1fr_1fr] px-6 items-center bg-dark-grey p-4 rounded-lg font-semibold hover:bg-pitch-black-500 transition ease-in-out duration-300 h-24"
        >
          <img src="../../assets/images/add.svg" class="justify-self-start" />
          <img
            src="../../assets/images/outlook-icon.svg"
            alt="Outlook"
            class="w-12 h-12 mx-auto"
          />
          <span class="flex items-center mx-auto"> Outlook </span>
        </button>

        <button
          class="w-full grid grid-cols-[1.2fr_1fr_1fr] px-6 items-center bg-dark-grey p-4 rounded-lg font-semibold hover:bg-pitch-black-500 transition ease-in-out duration-300 h-24"
        >
          <img src="../../assets/images/add.svg" class="justify-self-start" />

          <img
            src="../../assets/images/yahoo-icon.svg"
            alt="Yahoo Mail"
            class="w-16 h-16 mx-auto"
          />
          <span class="flex items-center mx-auto"> Yahoo Mail </span>
        </button>
      </div>

      <!-- Why is this necessary? Section -->
      <div class="mt-auto mb-2">
        <a href="#" class="text-prime-golden text-sm underline opacity-0">
          Why is this necessary?
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import authService from "@/api/authService";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { onMounted } from "vue";
import { useUserStore } from "@/stores/user";

const router = useRouter();

const authStore = useAuthStore();

const linkGmail = async () => {
  try {
    // build the full redirect URL at runtime
    const redirectUrl = new URL(
      "/link-email-success",
      process.env.VUE_APP_BASE_URL
    ).toString();

    const { data } = await authService.getGmailAuthorizationUrl(redirectUrl);
    window.location.href = data.authorize_url;
  } catch (error) {
    console.error("Error fetching Gmail authorization URL:", error);
    router.push({ name: "LinkEmailSuccessPage", query: { error: "true" } });
  }
};

const linkOutlook = async () => {
  try {
    // build full redirect URL at runtime
    const redirectUrl = new URL(
      "/link-email-success",
      process.env.VUE_APP_BASE_URL
    ).toString();

    const { data } = await authService.getOutlookAuthorizationUrl(redirectUrl);
    window.location.href = data.authorize_url;
  } catch (error) {
    console.error("Error fetching Outlook authorization URL:", error);
    router.push({ name: "LinkEmailSuccessPage", query: { error: "true" } });
  }
};

const logout = async () => {
  await authStore.logout();
  router.push({ name: "LogIn" });
};
</script>

<style scoped>
/* Add any custom styling here if necessary */
</style>
